import { h } from 'preact';

const Telegram = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M13.557 2.799L2.209 7.176a.326.326 0 00.003.61l2.765 1.032 1.07 3.442c.069.22.338.302.517.156l1.541-1.256a.462.462 0 01.561-.016l2.78 2.018a.325.325 0 00.51-.197l2.036-9.796a.325.325 0 00-.435-.37zm-2.165 2.29L6.933 9.235a.919.919 0 00-.286.552l-.152 1.127c-.02.151-.232.165-.273.02L5.637 8.88a.544.544 0 01.238-.612l5.404-3.328c.097-.06.197.072.113.149z" />
		</svg>
	);
};

export default Telegram;
